import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function RequestException() {
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  async function submit() {
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/proposals/exception-requests`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ reason })
      });
      if (res.ok) {
        alert('Request submitted to secretary.');
        navigate('/dashboard');
      } else {
        alert('Failed to submit. Try again.');
      }
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ maxWidth:720, margin:'24px auto', background:'#fff', borderRadius:12, padding:16, boxShadow:'0 2px 8px rgba(0,0,0,.08)' }}>
      <h2>Request Exception to Submit Another Proposal</h2>
      <p>Please explain why you need to submit multiple proposals before completing the current one.</p>
      <textarea
        rows={6}
        style={{ width:'100%', padding:8 }}
        value={reason}
        onChange={(e)=>setReason(e.target.value)}
        placeholder="Your reason..."
      />
      <div style={{ marginTop:12 }}>
        <button disabled={saving || !reason.trim()} onClick={submit}>Submit</button>
      </div>
    </div>
  );
}
